import type { PayLinkRowResponse } from "../services/payLinkService";
import { mapBusinessApiTxToRow } from "./businessSuiteTransactionRowMap";
import type { BusinessTransactionRow } from "./businessSuiteTransactionRowMap";
import { mapPaidPayLinksToBusinessTransactionRows } from "./businessPayLinkTransactionRows";

export function mapApiTransactionsToBusinessRows(
  results: unknown[]
): BusinessTransactionRow[] {
  return results
    .map((transaction) => mapBusinessApiTxToRow(transaction))
    .filter((row): row is BusinessTransactionRow => row !== null);
}

/** @deprecated Pay-link merge is handled in fetchBusinessTransactionHistoryPage. */
export function mergeBusinessPayLinkRows(
  rows: BusinessTransactionRow[],
  payLinks: unknown[] | undefined,
  page: number,
  filterType: string,
  filterStatus: string,
  pageSize = 5
): BusinessTransactionRow[] {
  if (
    page !== 1 ||
    filterType !== "all" ||
    filterStatus !== "all" ||
    !Array.isArray(payLinks) ||
    payLinks.length === 0
  ) {
    return rows.slice(0, pageSize);
  }

  const payLinkRows = mapPaidPayLinksToBusinessTransactionRows(
    payLinks as PayLinkRowResponse[]
  );

  return [...rows, ...payLinkRows]
    .sort((left, right) => (right.sortDate || 0) - (left.sortDate || 0))
    .slice(0, pageSize);
}
